import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { ThemeContextProvider } from './context/ThemeContext';
import { DeliveryFormProvider } from './context/DeliveryFormContext';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import { DeliveryProvider } from './context/DeliveryContext';
import { useAuth } from './context/AuthContext';

// Pages
import { SendPackage } from './pages/SendPackage';
import { Drive } from './pages/Drive/Drive';
import { TermsOfSale } from './pages/TermsOfSale';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { UserPage } from './pages/User/UserPage';
import { SharedDeliveryView } from './pages/SharedDeliveryView';
import { PrePaidDeliveryView } from './pages/PrePaidDeliveryView';
import { ReceiveDeliveryView } from './pages/ReceiveDeliveryView';
import DownloadApp from './pages/DownloadApp';


import Auth from './pages/Auth/Auth';
import CreateUser from './pages/Auth/CreateUser';
import JoinOrganization from './pages/Auth/JoinOrganization';
import InfoPage from './pages/Info/InfoPage';

// Layout
import Header from './components/Header/Header';
// import Footer from './components/Footer/Footer'; TODO this should be visible

// Redirects to /auth, preserving the intended destination for post-login redirect
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null; // swap for a spinner if you have one

  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      bgcolor: 'background.default',
    }}
    >
      <Header />
      <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default' }}>
        <Routes>

          {/* ── Public ── */}
          <Route path="/" element={<SendPackage />} />
          <Route path="/laheta-paketti" element={<SendPackage />} />
          <Route path="/send-package" element={<SendPackage />} />

          {/* Sender referral — courier shares this link with potential senders */}
          <Route path="/laheta/:shareId"   element={<SendPackage />} />
          
          {/* Receiver & shared — accessed via a link, no login needed */}
          <Route path="/vastaanota" element={<ReceiveDeliveryView />} />
          <Route path="/kuljeta/:shareId" element={<SharedDeliveryView />} />

          {/* Prepaid/order — external users arriving from a link */}
          <Route path="/tilaus" element={<PrePaidDeliveryView />} />
          <Route path="/order" element={<PrePaidDeliveryView />} />

          {/* Auth */}
          <Route path="/auth" element={<Auth />} />
          <Route path="/create-user" element={<CreateUser />} />
          <Route path="/join" element={<JoinOrganization />} />

          <Route path="/luo-kayttaja" element={<CreateUser />} />

          {/* Info & legal */}
          <Route path="/info" element={<InfoPage />} />
          <Route path="/terms-of-sale" element={<TermsOfSale />} />
          <Route path="/myyntiehdot" element={<TermsOfSale />} />
          <Route path="/terms" element={<TermsOfSale />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/tietosuojakaytanto" element={<PrivacyPolicy />} />

          {/* ── Auth-required ── */}
          <Route
            path="/kuljeta-paketti"
            element={<ProtectedRoute><Drive /></ProtectedRoute>}
          />
          <Route
            path="/kuljeta"
            element={<ProtectedRoute><Drive /></ProtectedRoute>}
          />
          <Route
            path="/profile"
            element={<ProtectedRoute><UserPage /></ProtectedRoute>}
          />
          <Route path="/lataa" element={<DownloadApp />} />

          <Route
            path="/profiili"
            element={<ProtectedRoute><UserPage /></ProtectedRoute>}
          />


          {/* 404 — redirect home */}
          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </Box>
      {/* <Footer />   */}
    </Box>
  );
}

function App() {
  return (
    <ThemeContextProvider>
      <Router>
        <AuthProvider>
          <UserProvider>
            <DeliveryProvider>
              <DeliveryFormProvider>
                <AppRoutes />
              </DeliveryFormProvider>
            </DeliveryProvider>
          </UserProvider>
        </AuthProvider>
      </Router>
    </ThemeContextProvider>
  );
}

export default App;